import { render, staticRenderFns } from "./DialogBalances.vue?vue&type=template&id=596c1e58&"
import script from "./DialogBalances.vue?vue&type=script&lang=js&"
export * from "./DialogBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports